import { render, staticRenderFns } from "./TvaList.vue?vue&type=template&id=48e4d93a&scoped=true&"
import script from "./TvaList.vue?vue&type=script&lang=js&"
export * from "./TvaList.vue?vue&type=script&lang=js&"
import style0 from "./TvaList.vue?vue&type=style&index=0&id=48e4d93a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e4d93a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48e4d93a')) {
      api.createRecord('48e4d93a', component.options)
    } else {
      api.reload('48e4d93a', component.options)
    }
    module.hot.accept("./TvaList.vue?vue&type=template&id=48e4d93a&scoped=true&", function () {
      api.rerender('48e4d93a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/tva/TvaList.vue"
export default component.exports